export default __webpack_public_path__ + "static/media/fpa51000.41390b33.png";